import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { BusinessListCard } from './components/BusinessListCard';
import { PourAvailabilityDeleteCard } from './components/PourAvailabilityDeleteCard';
import { PourAvailabilityDetailsCard } from './components/PourAvailabilityDetailsCard';

export function PourAvailabilityDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const pourAvailabilityQueryResults = useQuery({
        queryKey: ['pourAvailability', id],
        queryFn: () =>
            Api.Menu.PourAvailability.getPourAvailability(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={pourAvailabilityQueryResults}>
                {data => (
                    <Stack gap={2} sx={{ paddingBottom: 4 }}>
                        <PourAvailabilityDetailsCard pourAvailability={data} />

                        <BusinessListCard
                            pourAvailability={data}
                            refetch={pourAvailabilityQueryResults.refetch}
                        />

                        <Can I="delete" a="PourAvailability">
                            <PourAvailabilityDeleteCard
                                pourAvailability={data}
                            />
                        </Can>
                    </Stack>
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
